import { useContext } from 'react';
import { BannerFpContext } from '../../../../Contexts/BannerFpContext';
import { Grid, Paper } from '@mui/material';
import InputConfig from '../../../../Components/InputConfig';
import { CONFIG_STRUCTURE_KEYS } from '../../constants';
import { throwErrorIfKeyNotPresentOrInvalid } from '../../../../utilities/helpers';
import { toast } from 'react-toastify';
import { BANNER_FP_EDIT_MODES } from '../../../../core/constants';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';

const { SITE_ID, SITE_DOMAIN } = CONFIG_STRUCTURE_KEYS;

const SiteSettings = () => {
	const { bannerFpConfig, updateBannerFpConfig, bannerFpConfigEditMode } =
		useContext(BannerFpContext);
	const commonStyleClasses = useCommonStyles();

	const updateSiteId = (siteId) => {
		try {
			const clonedBannerFpConfig = structuredClone(bannerFpConfig);
			throwErrorIfKeyNotPresentOrInvalid(SITE_ID, bannerFpConfig, 'number');
			clonedBannerFpConfig[SITE_ID] = siteId;
			updateBannerFpConfig(clonedBannerFpConfig);
		} catch (err) {
			console.error(err);
			toast.error(err.message, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	};

	const updateSiteDomain = (siteDomain) => {
		try {
			const clonedBannerFpConfig = structuredClone(bannerFpConfig);
			throwErrorIfKeyNotPresentOrInvalid(SITE_DOMAIN, bannerFpConfig, 'string');
			clonedBannerFpConfig[SITE_DOMAIN] = siteDomain;
			updateBannerFpConfig(clonedBannerFpConfig);
		} catch (err) {
			console.error(err);
			toast.error(err.message, {
				position: toast.POSITION.BOTTOM_RIGHT
			});
		}
	};

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading headingName="Site" headingPath={['Dashboard', 'Banner Fp', 'Site Settings']} />

			<Grid container spacing={1} style={{ margin: '2rem 0 3rem 4rem', width: '90%' }}>
				{bannerFpConfig && (
					<>
						<Grid item xs={3}>
							<InputConfig
								isObjectEditor={false}
								directValue={bannerFpConfig[SITE_ID]}
								updateDirectValue={updateSiteId}
								label="Site Id"
								inputType="number"
								editable={bannerFpConfigEditMode === BANNER_FP_EDIT_MODES.CREATE}
							/>
						</Grid>
						<Grid item xs={3}>
							<InputConfig
								isObjectEditor={false}
								directValue={bannerFpConfig[SITE_DOMAIN]}
								updateDirectValue={updateSiteDomain}
								label="Site Domain"
								editable={bannerFpConfigEditMode === BANNER_FP_EDIT_MODES.CREATE}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</Paper>
	);
};
export default SiteSettings;
